import { makeStyles } from '@material-ui/styles'
import { padding } from 'polished'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  titulo: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  resumo: {
    marginTop: '4px',
    fontSize: '16px',
  },
  content: {
    borderTop: 'thin solid #CCC',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    fontSize: '15px',
    borderBottom: 'thin solid #CCC',
  },
  anuncioContent: {
    '& ul': {
      listStylePosition: 'inside',
      paddingLeft: theme.spacing(2),
      marginTop: theme.spacing(1),
    },
    '& li': {
      marginBottom: theme.spacing(1),
    },
    '& table': {
      marginTop: theme.spacing(1),
      padding: theme.spacing(2),
    },

    '& table td': {
      padding: theme.spacing(1),
    },
    fontFamily: 'Roboto, sans-serif',
  },
}))

export default useStyles
